import type { ProductUpsellsConfig } from '#types/config/components/product/upsells'

export default {
  brandClasses: {
    title: 'body-4'
  }
} satisfies ProductUpsellsConfig
